__turbopack_context__.v({
  "accent": "button-module-sass-module__ifgiPG__accent",
  "accentLoading": "button-module-sass-module__ifgiPG__accentLoading",
  "accentWithLoader": "button-module-sass-module__ifgiPG__accentWithLoader",
  "breadcrumb": "button-module-sass-module__ifgiPG__breadcrumb",
  "button": "button-module-sass-module__ifgiPG__button",
  "buttonLoading": "button-module-sass-module__ifgiPG__buttonLoading",
  "default-transition": "button-module-sass-module__ifgiPG__default-transition",
  "dividerHorizontal": "button-module-sass-module__ifgiPG__dividerHorizontal",
  "dividerVertical": "button-module-sass-module__ifgiPG__dividerVertical",
  "focus-accent-outline": "button-module-sass-module__ifgiPG__focus-accent-outline",
  "hWrapper": "button-module-sass-module__ifgiPG__hWrapper",
  "input": "button-module-sass-module__ifgiPG__input",
  "key": "button-module-sass-module__ifgiPG__key",
  "linkPlain": "button-module-sass-module__ifgiPG__linkPlain",
  "linkPlainAccent": "button-module-sass-module__ifgiPG__linkPlainAccent",
  "linkSpan": "button-module-sass-module__ifgiPG__linkSpan",
  "linkText": "button-module-sass-module__ifgiPG__linkText",
  "loading": "button-module-sass-module__ifgiPG__loading",
  "opacity-hover": "button-module-sass-module__ifgiPG__opacity-hover",
  "primary": "button-module-sass-module__ifgiPG__primary",
  "rotation": "button-module-sass-module__ifgiPG__rotation",
  "secondary": "button-module-sass-module__ifgiPG__secondary",
  "secondaryFit": "button-module-sass-module__ifgiPG__secondaryFit",
  "secondaryLoading": "button-module-sass-module__ifgiPG__secondaryLoading",
  "spinner": "button-module-sass-module__ifgiPG__spinner",
  "themeDependent": "button-module-sass-module__ifgiPG__themeDependent",
  "themeDependentAndBright": "button-module-sass-module__ifgiPG__themeDependentAndBright",
  "vWrapper": "button-module-sass-module__ifgiPG__vWrapper",
});
